import moment from 'moment-timezone';
import 'moment/locale/es'; // Importamos el idioma español para los meses

// Función helper para convertir la fecha a hora local de México
export const convertToDateMX = (isoDate) => {
  if (!isoDate) return '';

  // Parseamos la fecha ISO y la convertimos a hora local
  const date = moment.utc(isoDate).tz('America/Mexico_City').locale('es');

  // Formateamos la fecha (ej. "04 de marzo 2026")
  let mexicoTime = date.format('DD [de] MMMM YYYY');

  // Capitalizamos la primera letra del mes para que diga "Marzo" en lugar de "marzo"
  const parts = mexicoTime.split(' ');
  // parts[0] = DD, parts[1] = "de", parts[2] = mes, parts[3] = YYYY
  if (parts.length > 2) {
    parts[2] = parts[2].charAt(0).toUpperCase() + parts[2].slice(1);
    mexicoTime = parts.join(' ');
  }

  return mexicoTime;
};
